/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import IntegrationsimawareImawareIntegration1 from './IntegrationsimawareImawareIntegration1';

/**
 * The IntegrationsImawareBody1 model module.
 * @module model/IntegrationsImawareBody1
 * @version v0.3
 */
export default class IntegrationsImawareBody1 {
  /**
   * Constructs a new <code>IntegrationsImawareBody1</code>.
   * @alias module:model/IntegrationsImawareBody1
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationsImawareBody1</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsImawareBody1} obj Optional instance to populate.
   * @return {module:model/IntegrationsImawareBody1} The populated <code>IntegrationsImawareBody1</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsImawareBody1();
      if (data.hasOwnProperty('imaware_integration'))
        obj.imawareIntegration = IntegrationsimawareImawareIntegration1.constructFromObject(data['imaware_integration']);
    }
    return obj;
  }
}

/**
 * @member {module:model/IntegrationsimawareImawareIntegration1} imawareIntegration
 */
IntegrationsImawareBody1.prototype.imawareIntegration = undefined;

